export const colorFormatted = (palette, color) => {
  if (!palette) return

  const workingPalette = { ...palette }

  if (color?.split('.').length <= 1) return color
  const newColor =
    color?.split('.').reduce((acc, part) => {
      const res = acc?.[part]
      return res
    }, workingPalette) ?? color

  return newColor
}
